import React from 'react'
import styled, { css } from 'styled-components'
import { getAbsoluteLink } from '../../../helpers/utils'
import GenericLink from './GenericLink'

const v4 = css`
  border-top: 0;
  margin-top: unset;
  padding-top: unset;
  flex-direction: column;

  .header {
    text-transform: uppercase;
    font-size: 16px;
    letter-spacing: 0.5px;
    line-height: 24px;
    padding: 0 0 20px 0;
    margin: 0;
    margin-bottom: 0;
    color: #000;
  }
  .links {
    gap: 20px;
    flex-direction: column;
  }
`

const Wrapper = styled.div`
  display: flex;
  border-top: 1px solid #e3e9ef;
  padding-top: 60px;
  margin-top: 50px;
  justify-content: flex-start;
  width: 100%;

  .header {
    font-size: 26px;
    font-weight: 600;
    color: var(--clr-tf-main);
    margin-right: 10%;
  }

  .links {
    display: flex;
    gap: 25px;
  }

  @media (max-width: 991px) {
    margin-top: 0;
    border: 0;
    .links {
      width: 100%;
      justify-content: space-evenly;
    }
  }
  ${props => props.version == 'v4' && v4}
`

const Shop = ({ data, title, className, version }) => {
  return (
    <Wrapper className={className} version={version}>
      <div className="header hidden-xs hidden-sm">{title}</div>
      <div className="links">
        {data.map((link, i) => {
          return (
            <GenericLink
              key={i}
              name={link.ctaText}
              icon={getAbsoluteLink(link.iconPath, version)}
              path={getAbsoluteLink(link.ctaPath, version)}
              version={version}
            />
          )
        })}
      </div>
    </Wrapper>
  )
}

export default Shop



// WEBPACK FOOTER //
// ./src/components/Navbar/components/Shop.js